import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CsvService {
  downloadJsonAsCsv<T extends Record<string, any>>(
    rows: T[],
    opts?: {
      filename?: string;
      headers?: (keyof T | string)[];
      headerMap?: Record<string, string>;
      includeBOM?: boolean;
    }
  ): void {
    // ... paste the same body from Option A, but remove the function keyword
    // and keep it as a method. Everything else identical.
    const {
      filename = "data.csv",
      headers,
      headerMap = {},
      includeBOM = true,
    } = opts ?? {};

    const triggerDownload = (b: Blob, name: string) => {
      const navAny = navigator as any;
      if (typeof navAny?.msSaveOrOpenBlob === "function") {
        navAny.msSaveOrOpenBlob(b, name);
        return;
      }
      const url = URL.createObjectURL(b);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    };

    if (!Array.isArray(rows) || rows.length === 0) {
      const empty = includeBOM ? "\uFEFF" : "";
      const blob = new Blob([empty], { type: "text/csv;charset=utf-8" });
      triggerDownload(blob, filename);
      return;
    }

    const headerList: string[] =
      headers?.map(String) ??
      Array.from(
        rows.reduce<Set<string>>((acc, r) => {
          Object.keys(r ?? {}).forEach((k) => acc.add(k));
          return acc;
        }, new Set<string>())
      );

    const escapeCell = (value: unknown): string => {
      if (value == null) return "";
      let s: string;
      if (typeof value === "object") {
        try { s = JSON.stringify(value); } catch { s = String(value); }
      } else {
        s = String(value);
      }
      s = s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const headerLine = headerList.map(h => escapeCell(headerMap[h] ?? h)).join(",");
    const bodyLines = rows.map(row => headerList.map(h => escapeCell((row as any)[h])).join(","));
    const csv = [headerLine, ...bodyLines].join("\n");
    const payload = includeBOM ? "\uFEFF" + csv : csv;

    const blob = new Blob([payload], { type: "text/csv;charset=utf-8" });
    triggerDownload(blob, filename);
  }
}
